import { render, staticRenderFns } from "./soldeConge.vue?vue&type=template&id=0a1311c7&scoped=true&"
import script from "./soldeConge.vue?vue&type=script&lang=js&"
export * from "./soldeConge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1311c7",
  null
  
)

export default component.exports